import { FieldError, FieldErrors } from 'react-hook-form';

import { interpolateErrorVariables, parseErrorMessage } from 'support/helpers/formErrors/formErrors';

import { TaskError } from './types';

const traverseErrors = (
  obj: Record<string, unknown>,
  variables: Record<string, string>,
  errors: Array<TaskError>,
  parentKey = '',
): void => {
  if (typeof obj !== 'object' || obj === null) {
    return;
  }

  for (const key of Object.keys(obj)) {
    if (key === 'ref') {
      continue;
    }

    const fullPath = parentKey ? `${parentKey}.${key}` : key;

    if (key === 'message') {
      const parsed = parseErrorMessage(obj.message);
      const { title, description } = interpolateErrorVariables(parsed, variables);
      errors.push({
        id: parentKey,
        title,
        description,
        type: (obj as FieldError).type,
      });
    } else if (typeof obj[key] === 'object' && obj[key]) {
      traverseErrors(obj[key] as Record<string, unknown>, variables, errors, fullPath);
    }
  }
};

export const getAllTaskErrors = (errors: FieldErrors, variables: Record<string, string>): Array<TaskError> => {
  const taskErrors: Array<TaskError> = [];
  traverseErrors(errors, variables, taskErrors);
  return taskErrors;
};
